<template>
  <simple-edit-base
    ref="simpleEditBase"
    v-bind="$data"
  >
    <template #header-description>
      <p class="opc-simple-header__description-text">
        <span>{{ configDesc }}</span>
        <participants-diff-popover :type="planType" :color="'var(--zoom-color-text-neutral, #686F79)'" />
      </p>
    </template>

    <template #footer>
      <p v-if="addMoreVisible" class="opc-simple-edit-base__footer-text">
        <span>{{ $t("billing.simple_edit.want_additional_plan_tip", { planName: title }) }}&nbsp;</span>
        <zm-button
          type="link"
          @click="handleAddPlan"
        >
          {{ $t("billing.simple_edit.add_plan") }}
        </zm-button>
      </p>
    </template>
  </simple-edit-base>
</template>
<script>
import SimpleEditBase from "@/components/simple-edit/base.vue";
import planCommon from "@/plans/WEBINAR/mixin";
import ParticipantsDiffPopover from "@/plans/LARGE_MEETING/component/participants-diff-popover.vue";
import { mapGetters } from "vuex";
import { jumpToTargetPageForDiffType } from "@/utils/modal-utils";
import { getPlanTotalLicense } from "@/common/service/validate";
import { toLowercaseString } from "@/common/utils";

export default {
  name: "WebinarEditSimple",
  components: { ParticipantsDiffPopover, SimpleEditBase },
  mixins: [planCommon],
  data() {
    return {
      showCapacity: true,
      mounted: false,
      licensesMax: 999,
      maxCapacityDesc: '',
    };
  },
  computed: {
    ...mapGetters(["currentEditPlan", "isDisableAdd2Cart", "basicConfig", "getSelectedPlans"]),
    selectedPlan() {
      return this.getSelectedPlans?.[0];
    },
    configDesc() {
      return `${this.$t("billing.webinar.engage_your_audiences_desc")} ${this.$t("billing.webinar.up_to_x_attendees_y_panelists", [this.maxCapacityDesc, 100])}`;
    },
    isBulkLicenseAccount() {
      return this.basicConfig?.isBulkLicenseAccount;
    },
    addMoreVisible() {
      if (!this.mounted) {
        return false;
      }
      return !this.isDisableAdd2Cart && this.$refs.simpleEditBase.selectableCapacities.length > 1 && !this.isBulkLicenseAccount;
    },
    addFlowLink() {
      if (!this.mounted) {
        return "";
      }
      const simpleEditBase = this.$refs.simpleEditBase;
      const basePlan = simpleEditBase.currentBasePlans[0] || {};
      const basePlanCount = getPlanTotalLicense(simpleEditBase.currentBasePlans || []);
      return `/opc/buy/add?plan=${basePlan?.category}&subPlan=newsubs&from_sub=webinar&type=add&majorPlanHost=${basePlanCount}`;
    },
  },
  watch: {
    selectedPlan: {
      handler(selectedPlan) {
        if (selectedPlan) {
          this.maxCapacityDesc = toLowercaseString(selectedPlan?.capacityDesc) || this.$t("billing.event_services.unit.million_1_uppercase");
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleAddPlan() {
      jumpToTargetPageForDiffType(this.addFlowLink);
    },
  },
  mounted() {
    this.mounted = true;
  },
};
</script>

<style lang="scss" scoped>
.opc-simple-edit-base {
  &__footer-text {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.15px;
    margin-top: 16px;
  }
}
.opc-simple-header__description-text {
  line-height: 1.5;
  font-size: 14px;
}
</style>
